import React from "react";
import DocumentRow from "./DocumentRow";

const FormsSection = ({
  forms,
  lastErrorLocation,
  onSwitchChange,
  onScoreChange,
  onLastErrorChange,
  embedded = false,
  mandatorySubtitle = "Mandatory for all staff",
}) => {
  return (
    <div className={`bg-white overflow-hidden ${embedded ? "border-0" : "rounded-lg border border-gray-200 shadow-sm"}`}>
      {/*<div className="flex items-center justify-between gap-3 px-5 py-4 bg-gray-50/80 border-b border-gray-200">*/}
      {/*  <div className="flex items-center gap-2">*/}
      {/*    <span className="text-sm font-medium text-gray-900">*/}
      {/*      System Standard Forms*/}
      {/*    </span>*/}
      {/*  </div>*/}
      {/*  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-700">*/}
      {/*    Fixed List*/}
      {/*  </span>*/}
      {/*</div>*/}
      <div className="divide-y divide-gray-100 bg-white px-1">
        {forms.map((item, idx) => (
          <DocumentRow
            key={`${item.id}-${idx}`}
            item={item}
            complianceType="form"
            lastErrorLocation={lastErrorLocation}
            onSwitchChange={onSwitchChange}
            onScoreChange={onScoreChange}
            onLastErrorChange={onLastErrorChange}
            icon="form"
            mandatorySubtitle={mandatorySubtitle}
          />
        ))}
      </div>
      <p className="px-5 py-4 text-xs text-gray-500 border-t border-gray-100 bg-gray-50/50">
        Forms are system-defined and cannot be reordered.
      </p>
    </div>
  );
};

export default FormsSection;
